
const AppLoaderTable = () => {

    return (
        <>
            <div className="spinner-border TableLoaderStyling" role="status">
                <span className="visually-hidden">Loading...</span>
            </div>
        </>
    );
};

export default AppLoaderTable;